import React from 'react';
import moment from 'moment';

export const speakerBaseColumns = [
  {
    Header: 'Speaker ID',
    accessor: 'speakerid',
    sortable: true,
  },
  {
    Header: 'Phone Number',
    accessor: 'phone',
    sortable: false,
  }
];


export const speakerInnerColumns = [
  { 
    Header: 'Pin', 
    accessor: 'pin',
    sortable: true,
    minWidth: 60,
    style: {
      backgroundColor:'#DDD', 
      textAlign: 'center', 
    }
  },
  { 
    Header: 'Part', 
    accessor: 'part',
    sortable: false,
    minWidth: 40,
    style: {
      backgroundColor:'#DDD', 
      textAlign: 'center', 
    }
  },
  { 
    Header: 'Pin Status',
    accessor: item => (new Date() < new Date(item.pin1.conversational.edges[0].node.scheduledConference.endtime)) ? 'Active' : 'Expired',
    id: 'active',
    sortable: false,
    filterable: false,
    minWidth: 70,
    style: {
      backgroundColor:'#DDD', 
      textAlign: 'center', 
    }
  },
  { 
    Header: 'Call Start',
    accessor: 'callStart',
    sortable: true,
    minWidth: 70,
    style: {
      backgroundColor:'#DDD'
    },
    Cell: row => <div>{moment(row.value).format("YYYY/MM/DD HH:mm:ss.SS")}</div>
  },
  { 
    Header: 'Duration', 
    accessor: 'callDuration',
    minWidth: 70,
    sortable: false,
    style: {
      backgroundColor:'#DDD', 
      textAlign: 'center', 
    }
  },
  { 
    Header: 'Demog In',
    accessor: 'demographicInline',
    sortable: false,
    style: {
      backgroundColor:'#DDD', 
      textAlign: 'center', 
    }
  },
  { 
    Header: 'Demog Out', 
    accessor: 'demographicOutline',
    sortable: false,
    style: {
      backgroundColor:'#DDD', 
      textAlign: 'center', 
    }
  },
  { 
    Header: 'Phone # Inline', 
    accessor: 'speakerInline.phonenumber',
    sortable: false,
    style: {
      backgroundColor:'#DDD', 
      textAlign: 'center', 
    }
  },
  { 
    Header: 'Phone # Outline', 
    accessor: 'speakerOutline.phonenumber',
    sortable: false,
    style: {
      backgroundColor:'#DDD', 
      textAlign: 'center', 
    }
  }
];

export const pinBaseColumns = [
  {
    Header: 'Pin',
    accessor: 'pin',
    sortable: true,
    minWidth: 30
  },
  {
    Header: 'Owner',
    accessor: 'owner',
    id: 'owner',
    sortable: false,
  },
  {
    Header: 'Status',
    accessor: 'status',
    id: 'active',
    sortable: false,
    minWidth: 50, 
    filterable: false
  },
  {
    Header: 'Current',
    accessor: 'currentRecordingLength',
    sortable: false,
    minWidth: 40
  },
  {
    Header: 'Max',
    accessor:'maxRecordingLength',
    sortable: false,
    minWidth: 40
  }
];

export const pinInnerColumns = [
  { 
    Header: 'SPID In', 
    accessor: 'speakerInline.speakerId',
    sortable: true,
    minWidth: 60
  },
  { 
    Header: 'SPID Out', 
    accessor: 'speakerOutline.speakerId',
    sortable: true,
    minWidth: 70
  },
  { 
    Header: 'Part', 
    accessor: 'part',
    sortable: false,
    minWidth: 40,
    style: {
      textAlign: 'center', 
    }
  },
  { 
    Header: 'Call Start', 
    accessor: 'callStart',
    sortable: true,
    minWidth: 70,
    Cell: row => <div>{moment(row.value).format("YYYY/MM/DD HH:mm:ss.SS")}</div>
  },
  { 
    Header: 'Duration', 
    accessor: 'callDuration',
    sortable: false,
    minWidth: 60,
    style: { 
      textAlign: 'center',
    }
  },
  { 
    Header: "Demog Inline",
    accessor: 'demographicInline',
    sortable: false,
  },
  { 
    Header: 'Demog Outline', 
    accessor: 'demographicOutline',
    sortable: false
  },
  { 
    Header: 'Phone # Inline', 
    accessor: 'speakerInline.phonenumber',
    sortable: false
  },
  { 
    Header: 'Phone # Outline', 
    accessor: 'speakerOutline.phonenumber',
    sortable: false,
    style: {
      textAlign: 'center'
    }
  }
];

export const callLogColumns = [
  {
    Header: 'Call ID',
    accessor: 'cid',
    sortable: true,
    style: {
      textAlign: 'center', 
    }
  },
  {
    Header: 'Step',
    accessor: 'step',
    sortable: false,
    style: {
      textAlign: 'center', 
    }
  },
  {
    Header: 'Message',
    accessor: 'message',
    sortable: false,
    style: {
      textAlign: 'center', 
    }
  },
  {
    Header: 'DTMF',
    accessor: 'dtmf',
    sortable: false,
    style: {
      textAlign: 'center', 
    }
  },
  {
    Header: 'Timestamp',
    accessor: 'timeStamp',
    sortable: true,
    style: {
      textAlign: 'center', 
    }
  }
]


// WEBPACK FOOTER //
// ./src/views/pin/constant.js